/* NetworkBars — 4-bar call-quality indicator driven by Agora's
   `network-quality` event (1 = excellent … 6 = down, 0 = unknown).
   Shared by the resident's ConnectedCallView and the visitor page. */

const BAR_HEIGHTS = [5, 8, 11, 14];
// quality → number of lit bars
const LIT = { 1: 4, 2: 3, 3: 2, 4: 1, 5: 1, 6: 0 };

export default function NetworkBars({ quality = 0, testId = "net-quality" }) {
  const lit = LIT[quality] ?? 0;
  const color =
    quality === 0 ? "bg-gray-500"
      : quality <= 2 ? "bg-emerald-400"
        : quality === 3 ? "bg-amber-400"
          : "bg-red-400";
  const label =
    quality === 0 ? "Checking network…"
      : quality <= 2 ? "Good connection"
        : quality === 3 ? "Fair connection"
          : quality >= 6 ? "No connection"
            : "Poor connection";
  return (
    <div
      className="inline-flex items-end gap-[3px] px-2 py-1.5 rounded-full bg-black/60 backdrop-blur-sm"
      title={label}
      aria-label={label}
      data-testid={testId}
      data-quality={quality}
    >
      {BAR_HEIGHTS.map((h, i) => (
        <span
          key={h}
          className={`w-[3px] rounded-sm ${i < lit ? color : "bg-white/25"}`}
          style={{ height: `${h}px` }}
        />
      ))}
    </div>
  );
}
